module.exports = __webpack_public_path__ + "img/trade-img-spex.357714f9.png";